/* eslint-disable */
export function ConvertObjectResultSaerch(newObj) {
    const attributes = (newObj && newObj.attributes) || {};
    const regulations = (newObj && newObj.regulations && newObj.regulations.length > 0) ? newObj.regulations[0] : {};
    const geometry = (newObj && newObj.geometry) || {};
    const spatialReference = geometry.spatialReference || {};
    const rings = geometry.rings || [];    

    return {
        landUse:newObj?.landUse?newObj?.landUse?.toString():"" ,
        OBJECTID: regulations.OBJECTID || null,
        FID_Parcels_Intersect: null,
        ZONE_ID: regulations.ZONE_ID || null,
        FID_PRA_Parcels: null,
        VILL_CODE: attributes.vilCode || "",
        HOD_CODE: attributes.hodCode || "",
        SECTOR_COD: attributes.sectorCode || "",
        SHEET_NO: null,
        PARCEL_ID: attributes.parcelId || "",
        DLS_KEY: attributes.dlsKey || "",
        PARCEL_TYP: null,
        PARCEL_INF: null,
        PARCEL_PAR: null,
        TRANSACTIO: null,
        IS_TREASUR: null,
        TEMP_P_ID: " ",
        PARCEL_ID_: 1,
        CREATION_U: " ",
        CREATION_D: null,
        LASTMODIFI: " ",
        LASTMODI_1: null,
        VELL_NAME: attributes.vilName || "",
        HOD_NAME: attributes.hodName || "",
        reg_area: null,
        FID_PRA_Zoning: null,
        FID_PRA_Parcels_Update: null,
        IS_PRINTABLE: newObj.isPrintable ? 1 : 0,
        "Shape.STArea()": attributes.area || null,
        "Shape.STLength()": null,
        Zone_ID_Text: null,
        FID_PRA_Parcels_Update_ISO: "1970-01-01",
        geometry: {
            spatialReference: {
                latestWkid: spatialReference.latestWkid || null,
                wkid: spatialReference.wkid || null
            },
            rings: rings
        },
        isPrintable: newObj.isPrintable ? 1 : 0,
        zoneCodeArray:newObj?.zoneCodeArray
    };
}
